import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './PublicNavbar.module.css';

const PublicNavbar = () => {
    const location = useLocation();
    const isAuthPage = ['/login', '/register'].includes(location.pathname);

    return (
        <header className={styles.header}>
            <div className={styles.shell}>
                <Link className={styles.brand} to="/">
                    LtW
                </Link>

                <nav className={styles.nav}>
                    <Link to="/">Home</Link>
                    <Link to="/coaches">Coaches</Link>
                    <Link to="/login">Login</Link>
                    <Link className={styles.primaryLink} to={isAuthPage ? '/' : '/register'}>
                        {isAuthPage ? 'Explore Product' : 'Start Free'}
                    </Link>
                </nav>
            </div>
        </header>
    );
};

export default PublicNavbar;
